var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.229 20.834",
    width: 20,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.115 10.416c-1.432 0 -2.604 1.172 -2.604 2.604c0 1.432 1.172 2.604 2.604 2.604c1.432 0 2.604 -1.172 2.604 -2.604C11.719 11.589 10.548 10.416 9.115 10.416zM17.623 5.252l-3.414 -3.414C13.879 1.507 13.379 1.302 12.861 1.302H2.604C1.166 1.302 0 2.467 0 3.906v13.021c0 1.439 1.166 2.604 2.604 2.604h13.021c1.439 0 2.604 -1.166 2.604 -2.604V6.67C18.229 6.152 18.021 5.652 17.623 5.252zM5.209 3.255h5.86V6.51H5.209V3.255zM16.276 16.927c0 0.36 -0.291 0.651 -0.651 0.651H2.604c-0.36 0 -0.651 -0.291 -0.651 -0.651V3.906c0 -0.36 0.291 -0.651 0.651 -0.651h0.651v4.232c0 0.539 0.438 0.976 0.976 0.976h7.813C12.585 8.464 13.021 8.029 13.021 7.486V3.414l3.184 3.184C16.251 6.641 16.276 6.705 16.276 6.766V16.927z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveGreen);
export default __webpack_public_path__ + "static/media/SaveGreen.2d3c5520ca79ab61259cdaceaf8e99bb.svg";
export { ForwardRef as ReactComponent };